/**
 * Pixel da Meta nas telas públicas do app (hoje, o /cadastro).
 *
 * Por que não no app inteiro: dentro do CRM a pessoa já é cliente, e a
 * navegação dela (com id de contato e de oportunidade na URL) não tem por que
 * ir para a Meta. O que o anúncio precisa saber é só uma coisa — quem clicou
 * no "Testar grátis" do site chegou a criar a conta. Esse é o
 * `CompleteRegistration`, e é o que a Meta usa para otimizar a campanha.
 *
 * É o mesmo Pixel do site brikcrm.com.br, para a jornada ficar inteira:
 * anúncio → site → cadastro.
 */

const PIXEL_ID = '1473089884499023';

/** Só os endereços de produção do app medem. Homologação e localhost, não. */
const HOSTS_MEDIDOS = ['app.brikcrm.com.br', 'crm.gbcode.com.br'];

type Fbq = ((comando: string, nome: string, params?: Record<string, unknown>) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[];
  push?: unknown;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

const medindo = () => HOSTS_MEDIDOS.includes(window.location.hostname);

let carregado = false;

/** Carrega o código base do Pixel e conta a visita. Chamar uma vez, na tela pública. */
export function carregarPixelMeta() {
  if (carregado || !medindo()) return;
  carregado = true;

  /* Código base da Meta, igual ao do site. */
  const f = window;
  if (f.fbq) return;
  const n: Fbq = function (...args: unknown[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue!.push(args);
  } as unknown as Fbq;
  f.fbq = n;
  if (!f._fbq) f._fbq = n;
  (n as unknown as { push: unknown }).push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);

  window.fbq?.('init', PIXEL_ID);
  window.fbq?.('track', 'PageView');
}

/** Avisa a Meta de um evento padrão (ex.: a conta criada). Silencioso fora de produção. */
export function eventoMeta(nome: string, params?: Record<string, unknown>) {
  if (!medindo()) return;
  window.fbq?.('track', nome, params);
}

/** A conta nasceu: é esta a conversão que a campanha de "teste grátis" otimiza. */
export function contaCriadaNaMeta(origem: 'formulario' | 'google') {
  eventoMeta('CompleteRegistration', { content_name: 'teste-gratis', status: true, metodo: origem });
}
